<template>
  <section :class="$style.small_image_text_area" :style="{ background: blockBgColorRef }">
    <div :class="$style.image_area">
      <AtomsConsumerImage :src="imgUrl" :alt="imgUrlCaption" :class="{ 'page-parts-pc': !!spImgUrl }" :width="174" />
      <AtomsConsumerImage v-if="spImgUrl" :src="spImgUrl" :alt="spImgUrlCaption" class="page-parts-sp" :width="174" />
    </div>
    <div v-if="title" :class="$style.text_area">
      <h3 :class="[$style.title, fontSize, { 'page-parts-pc': !!spTitle }]" v-html="sanitizeHtmlContent(title)" />
      <h3 v-if="spTitle" :class="$style.title" class="page-parts-sp" v-html="sanitizeHtmlContent(spTitle)" />
      <div :class="$style.text_link">
        <p
          :class="[$style.text, descFontSize, { 'page-parts-pc': !!spDescription }]"
          v-html="sanitizeHtmlContent(description)"
        />
        <p
          v-if="spDescription"
          class="page-parts-sp"
          :class="[$style.text, descFontSize]"
          v-html="sanitizeHtmlContent(spDescription)"
        />
        <AtomsConsumerLink
          v-if="linkUrl"
          :url="linkUrl"
          :style="{ background: bgColorRef, color: textColorRef }"
          :class="$style.link_text"
          >{{ linkText ? linkText : "チェックする" }}</AtomsConsumerLink
        >
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { sanitizeHtmlContent } from "@tential/ec-gql-schema/utils/functions/sanitize"
type Props = {
  title: string
  spTitle?: string
  description?: string
  spDescription?: string
  fontSize?: string[]
  descFontSize?: string[]
  imgUrl: string
  spImgUrl?: string | null
  imgUrlCaption?: string
  spImgUrlCaption?: string
  linkUrl?: string
  linkText?: string
  bgColor?: string
  linkTextColor?: string
  blockBgColor?: string
}

const props = withDefaults(defineProps<Props>(), {
  title: "",
  spTitle: "",
  description: "",
  spDescription: "",
  fontSize: () => [],
  descFontSize: () => [],
  imgUrl: "",
  spImgUrl: null,
  imgUrlCaption: "",
  spImgUrlCaption: "",
  linkText: "",
  bgColor: "#fff",
  linkTextColor: "#fff",
  blockBgColor: "#fff",
  linkUrl: "",
})

const blockBgColorRef = computed(() => {
  return props.blockBgColor || "#F4F4F7"
})
const bgColorRef = computed(() => {
  return props.bgColor || "#8C8D94"
})
const textColorRef = computed(() => {
  return props.linkTextColor || "#ffffff"
})
</script>

<style scoped module lang="scss">
.small_image_text_area {
  background-color: $black-5;
  display: flex;
  .image_area {
    margin-right: 1rem;
    width: 21.1%;
    max-width: 174px;

    @include sp {
      margin-right: 0;
      width: 25.3%;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .text_area {
    padding: 1.75rem 1.375rem 1.3125rem;
    width: calc(100% - 21.1%);
    max-width: 676px;

    @include sp {
      width: calc(100% - 25.3%);
      padding: 1rem 1.25rem;
    }
    .title {
      font-size: 24px;
      font-weight: 700;
      letter-spacing: 0.11rem;
      line-height: 1.125;
      margin-bottom: 1rem;

      @include sp {
        font-size: 16px;
        margin-bottom: 6px;
      }
    }
    .text_link {
      display: flex;
      align-items: center;
      justify-content: space-between;

      @include less-tb {
        display: block;
        text-align: right;
      }
      .text {
        font-size: 13px;
        line-height: 1.846;
        letter-spacing: 0.1rem;
        white-space: pre-wrap;

        @include less-tb {
          text-align: left;
          margin-bottom: 1rem;
        }

        @include sp {
          font-size: 11px;
        }
      }
      .link_text {
        border-radius: 9999px;
        padding: 0.6875rem 2.1875rem;
        text-decoration: none;
        font-size: 14px;
        line-height: 1.21;

        @include less-tb {
          display: inline-block;
        }

        @include sp {
          font-size: 12px;
          line-height: 1.5;
          padding: 0.5rem 1.625rem;
        }
      }
    }
  }
}
</style>
